import { CalendarDateTime as e, getLocalTimeZone as t } from "@internationalized/date";
import { formatDistanceToNowStrict as n } from "date-fns";
import { millisecondsInDay as r, millisecondsInHour as i, millisecondsInMinute as a, millisecondsInSecond as o } from "date-fns/constants";
import { enUS as s } from "date-fns/locale/en-US";
import { af as ee } from "date-fns/locale/af";
import { ar as te } from "date-fns/locale/ar";
import { arDZ as ne } from "date-fns/locale/ar-DZ";
import { arEG as re } from "date-fns/locale/ar-EG";
import { arMA as ie } from "date-fns/locale/ar-MA";
import { arSA as ae } from "date-fns/locale/ar-SA";
import { arTN as oe } from "date-fns/locale/ar-TN";
import { az as se } from "date-fns/locale/az";
import { be as ce } from "date-fns/locale/be";
import { beTarask as le } from "date-fns/locale/be-tarask";
import { bg as ue } from "date-fns/locale/bg";
import { bn as de } from "date-fns/locale/bn";
import { bs as c } from "date-fns/locale/bs";
import { ca as l } from "date-fns/locale/ca";
import { ckb as u } from "date-fns/locale/ckb";
import { cs as d } from "date-fns/locale/cs";
import { cy as f } from "date-fns/locale/cy";
import { da as p } from "date-fns/locale/da";
import { de as m } from "date-fns/locale/de";
import { deAT as h } from "date-fns/locale/de-AT";
import { el as g } from "date-fns/locale/el";
import { enAU as _ } from "date-fns/locale/en-AU";
import { enCA as v } from "date-fns/locale/en-CA";
import { enGB as y } from "date-fns/locale/en-GB";
import { enIE as b } from "date-fns/locale/en-IE";
import { enIN as x } from "date-fns/locale/en-IN";
import { enNZ as S } from "date-fns/locale/en-NZ";
import { enZA as C } from "date-fns/locale/en-ZA";
import { eo as w } from "date-fns/locale/eo";
import { es as T } from "date-fns/locale/es";
import { et as E } from "date-fns/locale/et";
import { eu as D } from "date-fns/locale/eu";
import { faIR as O } from "date-fns/locale/fa-IR";
import { fi as k } from "date-fns/locale/fi";
import { fr as A } from "date-fns/locale/fr";
import { frCA as j } from "date-fns/locale/fr-CA";
import { frCH as M } from "date-fns/locale/fr-CH";
import { fy as N } from "date-fns/locale/fy";
import { gd as P } from "date-fns/locale/gd";
import { gl as F } from "date-fns/locale/gl";
import { gu as I } from "date-fns/locale/gu";
import { he as L } from "date-fns/locale/he";
import { hi as R } from "date-fns/locale/hi";
import { hr as z } from "date-fns/locale/hr";
import { ht as B } from "date-fns/locale/ht";
import { hu as V } from "date-fns/locale/hu";
import { hy as H } from "date-fns/locale/hy";
import { id as fe } from "date-fns/locale/id";
import { is as pe } from "date-fns/locale/is";
import { it as me } from "date-fns/locale/it";
import { itCH as he } from "date-fns/locale/it-CH";
import { ja as ge } from "date-fns/locale/ja";
import { jaHira as _e } from "date-fns/locale/ja-Hira";
import { ka as ve } from "date-fns/locale/ka";
import { kk as ye } from "date-fns/locale/kk";
import { km as be } from "date-fns/locale/km";
import { kn as xe } from "date-fns/locale/kn";
import { ko as Se } from "date-fns/locale/ko";
import { lb as Ce } from "date-fns/locale/lb";
import { lt as we } from "date-fns/locale/lt";
import { lv as Te } from "date-fns/locale/lv";
import { mk as Ee } from "date-fns/locale/mk";
import { mn as De } from "date-fns/locale/mn";
import { ms as Oe } from "date-fns/locale/ms";
import { mt as ke } from "date-fns/locale/mt";
import { nb as Ae } from "date-fns/locale/nb";
import { nl as je } from "date-fns/locale/nl";
import { nlBE as Me } from "date-fns/locale/nl-BE";
import { nn as U } from "date-fns/locale/nn";
import { oc as Ne } from "date-fns/locale/oc";
import { pl as Pe } from "date-fns/locale/pl";
import { pt as Fe } from "date-fns/locale/pt";
import { ptBR as Ie } from "date-fns/locale/pt-BR";
import { ro as Le } from "date-fns/locale/ro";
import { ru as Re } from "date-fns/locale/ru";
import { se as ze } from "date-fns/locale/se";
import { sk as Be } from "date-fns/locale/sk";
import { sl as Ve } from "date-fns/locale/sl";
import { sq as He } from "date-fns/locale/sq";
import { sr as Ue } from "date-fns/locale/sr";
import { srLatn as We } from "date-fns/locale/sr-Latn";
import { sv as Ge } from "date-fns/locale/sv";
import { ta as Ke } from "date-fns/locale/ta";
import { te as qe } from "date-fns/locale/te";
import { th as Je } from "date-fns/locale/th";
import { tr as Ye } from "date-fns/locale/tr";
import { ug as Xe } from "date-fns/locale/ug";
import { uk as Ze } from "date-fns/locale/uk";
import { uz as Qe } from "date-fns/locale/uz";
import { uzCyrl as $e } from "date-fns/locale/uz-Cyrl";
import { vi as et } from "date-fns/locale/vi";
import { zhCN as W } from "date-fns/locale/zh-CN";
import { zhHK as tt } from "date-fns/locale/zh-HK";
import { zhTW as nt } from "date-fns/locale/zh-TW";
//#region src/cookie.ts
var rt = 365;
function G() {
	return typeof document < "u";
}
function K() {
	let e = window.location.hostname;
	return e === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(e);
}
var it = /* @__PURE__ */ new Set([
	"co",
	"com",
	"net",
	"org",
	"ac",
	"gov",
	"edu"
]);
function q(e) {
	let t = e.split("."), n = t[t.length - 1], r = t[t.length - 2], i = t.length > 2 && n.length === 2 && it.has(r) ? 3 : 2;
	return t.length >= i ? `.${t.slice(-i).join(".")}` : null;
}
function at() {
	return K() ? null : q(window.location.hostname);
}
function ot(e) {
	return e ? `; domain=${e}` : "";
}
function st() {
	return K() ? "" : "; Secure";
}
function J(e) {
	if (!G()) return null;
	let t = `${e}=`;
	for (let e of document.cookie.split(";")) {
		let n = e.trimStart();
		if (n.startsWith(t)) return n.slice(t.length);
	}
	return null;
}
function Y(e, t = null) {
	G() && (document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${ot(t)}; SameSite=Lax${st()}`);
}
function ct(e, t, n = {}) {
	if (!G()) return;
	let r = new Date(Date.now() + (n.days ?? rt) * 24 * 60 * 60 * 1e3), i = at(), a = [
		`${e}=${t}`,
		`expires=${r.toUTCString()}`,
		"path=/",
		i ? `domain=${i}` : "",
		"SameSite=Lax",
		K() ? "" : "Secure"
	].filter(Boolean).join("; ");
	document.cookie = a, J(e) !== t && (Y(e, null), document.cookie = a);
}
//#endregion
//#region src/dateConversions.ts
function lt(t) {
	let n = /* @__PURE__ */ new Date(t * 1e3);
	return new e(n.getFullYear(), n.getMonth() + 1, n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds());
}
function ut(e) {
	if (!e) return 0;
	let n = e.toDate(t());
	return Math.floor(n.getTime() / 1e3);
}
//#endregion
//#region ../model-constants/src/constants/defaultLocale.ts
var X = "en-GB";
//#endregion
//#region src/formatCurrency.ts
function Z(e, t = X, n) {
	return new Intl.NumberFormat(t, {
		style: "currency",
		currency: e,
		currencyDisplay: "narrowSymbol",
		...n
	});
}
function dt(e, t, n = X, r) {
	return Z(t, n, r).format(e);
}
//#endregion
//#region src/modules/date-fns-locale-mapper.ts
var Q = {
	af: ee,
	ar: te,
	"ar-dz": ne,
	"ar-eg": re,
	"ar-ma": ie,
	"ar-sa": ae,
	"ar-tn": oe,
	az: se,
	be: ce,
	"be-tarask": le,
	bg: ue,
	bn: de,
	bs: c,
	ca: l,
	ckb: u,
	cs: d,
	cy: f,
	da: p,
	de: m,
	"de-at": h,
	el: g,
	en: s,
	"en-au": _,
	"en-ca": v,
	"en-gb": y,
	"en-ie": b,
	"en-in": x,
	"en-nz": S,
	"en-us": s,
	"en-za": C,
	eo: w,
	es: T,
	et: E,
	eu: D,
	fa: O,
	"fa-ir": O,
	fi: k,
	fr: A,
	"fr-ca": j,
	"fr-ch": M,
	fy: N,
	gd: P,
	gl: F,
	gu: I,
	he: L,
	hi: R,
	hr: z,
	ht: B,
	hu: V,
	hy: H,
	id: fe,
	is: pe,
	it: me,
	"it-ch": he,
	ja: ge,
	"ja-hira": _e,
	ka: ve,
	kk: ye,
	km: be,
	kn: xe,
	ko: Se,
	lb: Ce,
	lt: we,
	lv: Te,
	mk: Ee,
	mn: De,
	ms: Oe,
	mt: ke,
	nb: Ae,
	nl: je,
	"nl-be": Me,
	nn: U,
	oc: Ne,
	pl: Pe,
	pt: Fe,
	"pt-br": Ie,
	ro: Le,
	ru: Re,
	se: ze,
	sk: Be,
	sl: Ve,
	sq: He,
	sr: Ue,
	"sr-latn": We,
	sv: Ge,
	ta: Ke,
	te: qe,
	th: Je,
	tr: Ye,
	ug: Xe,
	uk: Ze,
	uz: Qe,
	"uz-cyrl": $e,
	vi: et,
	zh: W,
	"zh-cn": W,
	"zh-hk": tt,
	"zh-tw": nt
};
//#endregion
//#region src/formatDate.ts
function ft(e) {
	let t = e.toLowerCase().replace(/_/g, "-"), n = t.split("-")[0];
	return Q[t] ?? Q[n] ?? s;
}
function pt(e, t) {
	return n(e, {
		addSuffix: !0,
		locale: ft(t)
	});
}
function mt(e, t) {
	let n = Math.max(0, Date.now() - e.getTime()), s = (e, n) => new Intl.NumberFormat(t, {
		style: "unit",
		unit: n,
		unitDisplay: "narrow"
	}).format(Math.floor(e));
	return n >= r ? s(n / r, "day") : n >= i ? s(n / i, "hour") : n >= a ? s(n / a, "minute") : s(n / o, "second");
}
//#endregion
//#region src/formatNumber.ts
function ht(e, t, n) {
	return new Intl.NumberFormat(t, n).format(e);
}
//#endregion
//#region src/formatPrice.ts
function gt(e, t, n = X) {
	return e === void 0 ? "—" : new Intl.NumberFormat(n, {
		minimumFractionDigits: t,
		maximumFractionDigits: t
	}).format(e);
}
//#endregion
//#region src/formatProfit.ts
function _t(e, t = X) {
	return `${e >= 0 ? "+" : ""}${new Intl.NumberFormat(t, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(e)}`;
}
//#endregion
//#region src/withSign.ts
var vt = /^[\u200E\u200F\u061C]*/, yt = "‎";
function $(e, t) {
	return t ? e.replace(vt, (e) => `${e}${yt}${t}`) : e;
}
//#endregion
//#region src/formatSignedMoney.ts
function bt(e, t) {
	return $(t.format(Math.abs(e)).replace(/\s+/g, " "), e >= 0 ? "+" : "−");
}
//#endregion
//#region src/formatSignedPercent.ts
function xt(e) {
	let t = e * 100;
	return `${t >= 0 ? "+" : "−"}${Math.abs(t).toFixed(2)}%`;
}
//#endregion
//#region src/normalizeSymbols.ts
var St = /(?:\.ecn|[.#-])$/i, Ct = /\.ecn|#|\.|-/gi, wt = /USDT$/i;
function Tt(e) {
	return e.replace(St, "");
}
function Et(e) {
	return e.replace(Ct, "").replace(wt, "");
}
//#endregion
//#region src/url.ts
var Dt = (e) => {
	let t = new URL(e, window.location.origin);
	return new URLSearchParams(window.location.search).forEach((e, n) => {
		t.searchParams.set(n, e);
	}), t.toString();
};
//#endregion
export { Z as createCurrencyFormatter, ut as dateValueToSec, Y as deleteCookie, dt as formatCurrency, mt as formatElapsedTime, ht as formatNumber, gt as formatPrice, _t as formatProfit, pt as formatRelativeTime, bt as formatSignedMoney, xt as formatSignedPercent, J as getCookie, Et as normalizeSymbolIconName, Tt as normalizeSymbolTradingName, Dt as parseCurrentQuery, q as rootDomainOf, lt as secToDateValue, ct as setCookie, $ as withSign };
